<template>
    <div class="myedie">
        <header class=" fw600 f20 line28">编辑资料</header>
        <main class="margint20">
            <p>我的头像</p>
            <div class="img margint20">
                <input accept='image/*' @change="inputChange" type="file">
                <p>重新选择</p>
                <img class="ava" :src="userInfo.logo" alt="">
            </div>
            <div class="input margint20 flex_c_start">
                <label for="name">我的姓名</label>
                <input name="name" autocomplete="off" type="text" maxlength="15" v-model="userInfo.name" placeholder="请输入姓名">
            </div>
            <div class="input margint20 flex_c_start">
                <label  for="sign">个性签名</label>
                <input name="sign" autocomplete="off" type="text" maxlength="40" v-model="userInfo.note" placeholder="请输入个性签名">
            </div>
        </main>
        <div @click="editUser" class="save">保存资料</div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getToken, up, qiNiuHost } from '@/assets/js/qiniu'
export default {
    name: 'myEdit',
    data(){
        return {
            userInfo: {},
            token: '',
        }
    },
    mounted(){
        getToken().then(token=>this.token=token.uptoken)
        this.getUserInfo().then(data=>{
            this.userInfo = {
                name: data.name,
                logo: data.logo,
                note: data.note,
                uid: data.uid,
                src: ''
            }
        })
    },
    methods: {
        ...mapActions(['getUserInfo','getUser']),
        inputChange(e){
            let file = e.currentTarget.files[0]
            const _URL = window.URL || window.webkitURL;
            let src = _URL.createObjectURL(file)
            this.userInfo.logo = src;
            up(file,this.token).then(res=>{
                console.log(res)
                this.userInfo.src = qiNiuHost + res.key;
            })
        },
        async editUser(){
            let data = await this.$http.post(this.$api.editUser,{
                id: this.userInfo.uid,
                logo: this.userInfo.src || this.userInfo.logo,
                note: this.userInfo.note,
                name: this.userInfo.name
            })
            let uid = this.$getCookie('cy_uid');
            if (uid) {
                this.getUser({uid});
            }
            this.$message.success(data.msg)
            this.$router.back();
        }
    }
}
</script>
<style lang="less" scoped>
.img{
    position: relative;
    width: 120px;
    height: 120px;
    overflow: hidden;
    border-radius: 50%;
    input{
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
    .ava{
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
    }
    p{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 120px;
        height: 36px;
        color: #E6E6E6;
        line-height: 36px;
        text-align: center;
        background: rgba(0, 0, 0, 0.4);
    }
}
.input{
    font-size: 16px;
    line-height: 22px;
    label{
        font-weight: 600;
    }
    input{
        margin-top: 8px;
        width: 1184px;
        height: 44px;
        border-radius: 4px;
        padding: 10px;
        box-sizing: border-box;
        border: 1px solid #958F8F;
    }
}
.save{
    width: 104px;
    height: 36px;
    line-height: 36px;
    color: white;
    font-size: 16px;
    margin-top: 40px;
    text-align: center;
    cursor: pointer;
    background: #AD2729;
}
</style>